import * as yup from "yup";

export const consultarIndustrializadoSchema =  yup.object().shape({
  codigoBarras: yup.string().required("O código de barras é obrigatório")
});
  